module.exports = __webpack_public_path__ + "img/cross-circle-red.35bf5854.svg";